import { render, staticRenderFns } from "./BasicDataTab.vue?vue&type=template&id=49a93fde&scoped=true&"
import script from "./BasicDataTab.vue?vue&type=script&lang=js&"
export * from "./BasicDataTab.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataTab.vue?vue&type=style&index=0&id=49a93fde&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a93fde",
  null
  
)

component.options.__file = "BasicDataTab.vue"
export default component.exports